"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _Notification = require("../Notification");
var _SourceForm = require("./SourceForm.styled");
var ErrorNotification = function ErrorNotification(_ref) {
  var message = _ref.message,
    link = _ref.link;
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_SourceForm.StyledNotificationCol, null, /*#__PURE__*/_react["default"].createElement(_Notification.Notification, {
    type: "warning",
    linkMessage: link ? 'Learn more' : null,
    message: message,
    onClick: function onClick(e) {
      e.preventDefault();
      window.open(link, '_blank');
    }
  })));
};
ErrorNotification.propTypes = {
  message: _propTypes["default"].string,
  link: _propTypes["default"].string
};
var _default = exports["default"] = ErrorNotification;